import { useContext } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { ChangePasswordContext } from '../../../contexts/changePassword';

const LineThroughClass = new Map([
  [true, 'no-line-through'],
  [false, ''],
])

export const Rules = () => {
  const { rulesValidation } = useContext(ChangePasswordContext);

  return (
    <div className='flex flex-column justify-content-center gap-28 width-360 height-460'>
      <p className='font-26 m-0 p-0 tracking-wide'>Some Requirements!</p>

      <div className='flex flex-column gap-20'>
        <p className='font-18 m-0 p-0 line-24 tracking-wide'>Passwords must contain:</p>

        <div className='flex flex-column gap-8'>
          <div className='flex align-items-center gap-8'>
            <Checkbox
              title="current-password"
              className='checkbox'
              inputProps={{ 'aria-label': 'primary checkbox' }}
              checked={rulesValidation.get('current-password')}
            />
            <p className={`m-0 p-0 line-24 tracking-wide ${LineThroughClass.get(rulesValidation.get('current-password'))}`}>Must enter current password</p>
          </div>

          <div className='flex align-items-center gap-8'>
            <Checkbox
              title="8-characters"
              className='checkbox'
              inputProps={{ 'aria-label': 'primary checkbox' }}
              checked={rulesValidation.get('8-characters')}
            />
            <p className={`m-0 p-0 line-24 tracking-wide ${LineThroughClass.get(rulesValidation.get('8-characters'))}`}>At least 8 characters</p>
          </div>

          <div className='flex align-items-center gap-8'>
            <Checkbox
              title="1-uppercase"
              className='checkbox'
              inputProps={{ 'aria-label': 'primary checkbox' }}
              checked={rulesValidation.get('1-uppercase')}
            />
            <p className={`m-0 p-0 line-24 tracking-wide ${LineThroughClass.get(rulesValidation.get('1-uppercase'))}`}>At least 1 uppercase letter <span className='p-l-2 p-r-2 p-t-1 p-b-1 bg-primary-v2 color-white rounded-lg'>A - Z</span></p>
          </div>

          <div className='flex align-items-center gap-8'>
            <Checkbox
              title="1-lowercase"
              className='checkbox'
              inputProps={{ 'aria-label': 'primary checkbox' }}
              checked={rulesValidation.get('1-lowercase')}
            />
            <p className={`m-0 p-0 line-24 tracking-wide ${LineThroughClass.get(rulesValidation.get('1-lowercase'))}`}>At least 1 lowercase letter <span className='p-l-2 p-r-2 p-t-1 p-b-1 bg-primary-v2 color-white rounded-lg'>a - z</span></p>
          </div>

          <div className='flex align-items-center gap-8'>
            <Checkbox
              title="1-number"
              className='checkbox'
              inputProps={{ 'aria-label': 'primary checkbox' }}
              checked={rulesValidation.get('1-number')}
            />
            <p className={`m-0 p-0 line-24 tracking-wide ${LineThroughClass.get(rulesValidation.get('1-number'))}`}>At least 1 number <span className='p-l-2 p-r-2 p-t-1 p-b-1 bg-primary-v2 color-white rounded-lg'>0 - 9</span></p>
          </div>

          <div className='flex align-items-center gap-8'>
            <Checkbox
              title="1-special-character"
              className='checkbox'
              inputProps={{ 'aria-label': 'primary checkbox' }}
              checked={rulesValidation.get('1-special-character')}
            />
            <p className={`m-0 p-0 line-24 tracking-wide ${LineThroughClass.get(rulesValidation.get('1-special-character'))}`}>At least 1 of the following special characters: <span className='p-l-2 p-r-2 p-t-1 p-b-1 bg-primary-v2 color-white rounded-lg'>!@#$%^*-</span> but no other special character is allowed.</p>
          </div>

          <div className='flex align-items-center gap-8'>
            <Checkbox
              title="passwords-matched"
              className='checkbox'
              inputProps={{ 'aria-label': 'primary checkbox' }}
              checked={rulesValidation.get('passwords-matched')}
            />
            <p className={`m-0 p-0 line-24 tracking-wide ${LineThroughClass.get(rulesValidation.get('passwords-matched'))}`}>New password & confirm password must match</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rules;
